/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Ai_Processing_TitleInputs */

const en_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Processing and EU AI Act`)
};

const de_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Verarbeitung und EU AI Act`)
};

const fr_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement IA et Reglement UE sur l'IA`)
};

const es_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesamiento de IA y Ley de IA de la UE`)
};

const it_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattamento IA e Regolamento UE sull'IA`)
};

const nl_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-verwerking en EU AI-verordening`)
};

const pl_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie AI i akt UE o AI`)
};

const fi_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-käsittely ja EU:n tekoälysäädös`)
};

const da_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-behandling og EU AI Act`)
};

const sv_privacy_ai_processing_title = /** @type {(inputs: Privacy_Ai_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-behandling och EU:s AI-forordning`)
};

/**
* | output |
* | --- |
* | "AI Processing and EU AI Act" |
*
* @param {Privacy_Ai_Processing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_ai_processing_title = /** @type {((inputs?: Privacy_Ai_Processing_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Ai_Processing_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_ai_processing_title(inputs)
	if (locale === "fr") return fr_privacy_ai_processing_title(inputs)
	if (locale === "es") return es_privacy_ai_processing_title(inputs)
	if (locale === "it") return it_privacy_ai_processing_title(inputs)
	if (locale === "nl") return nl_privacy_ai_processing_title(inputs)
	if (locale === "pl") return pl_privacy_ai_processing_title(inputs)
	if (locale === "fi") return fi_privacy_ai_processing_title(inputs)
	if (locale === "da") return da_privacy_ai_processing_title(inputs)
	if (locale === "sv") return sv_privacy_ai_processing_title(inputs)
	return en_privacy_ai_processing_title(inputs)
});